import {
  FETCH_USER,
  LOGIN_USER,
  LOGOUT_USER,
  UPDATE_USER,
  RESET_USER,
  VERIFY_CODE,
  fetchUserBusy,
  fetchUserError,
  fetchUserSuccess,
  loginUserBusy,
  loginUserError,
  loginUserSuccess,
  logoutUserBusy,
  logoutUserError,
  logoutUserSuccess,
  updateUserBusy,
  updateUserError,
  updateUserSuccess,
  resetUserBusy,
  resetUserError,
  resetUserSuccess,
  verifyCodeBusy,
  verifyCodeError,
  verifyCodeSuccess,
} from "./action";
import { readServicesSaga } from "controllers/services/saga";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { login, logout, readUser, updateUser, resetUser, verifyCode } from "./api";

import { ActionTypes } from "../util";
import { BUSY_GLOBAL } from "../busy/action";
import { camelCase, mapKeys, merge, rearg, snakeCase } from "lodash";
import { logError } from "utils/utils";
import { reset } from "../action";

const { REQUEST } = ActionTypes;

const defaultPreferences = (user) => {
  if (!user) {
    return user;
  }
  // TODO declare default preferences in second object
  user.preferences = merge({}, {}, user.preferences);
  return user;
};

export const toCamelCase = (response) => mapKeys(response, rearg(camelCase, 1));
export const toSnakeCase = (payload) => mapKeys(payload, rearg(snakeCase, 1));

export function* readUserSaga() {
  try {
    yield put(fetchUserBusy(true));
    yield put(fetchUserError());
    let response = yield call(readUser);
    if (!response) {
      yield put(fetchUserSuccess());
      return;
    }
    response = yield call(defaultPreferences, response);
    response = yield call(toCamelCase, response);
    yield put(fetchUserSuccess(response));
  } catch (error) {
    logError(error);
    yield put(fetchUserError(error.message));
  } finally {
    yield put(fetchUserBusy(false));
  }
}

export function* updateUserSaga(action) {
  const body = toSnakeCase(action.payload);
  try {
    yield put(updateUserBusy(BUSY_GLOBAL));
    yield put(updateUserError());
    const response = yield call(updateUser, body);
    yield put(updateUserSuccess(response));
    yield call(readUserSaga);
    yield call(readServicesSaga);
  } catch (error) {
    logError(error);
    yield put(updateUserError(error.message));
  } finally {
    yield put(updateUserBusy(false));
  }
}

export function* loginSaga(action) {
  const body = action.payload;
  try {
    yield put(loginUserBusy(BUSY_GLOBAL));
    yield put(loginUserError());
    let response = yield call(login, body);
    response = yield call(toCamelCase, response);
    yield put(loginUserSuccess(response));
    yield call(readUserSaga);
    yield call(readServicesSaga);
  } catch (error) {
    logError(error);
    yield put(loginUserError(error.message));
  } finally {
    yield put(loginUserBusy(false));
  }
}

export function* logoutSaga() {
  try {
    yield put(logoutUserBusy(BUSY_GLOBAL));
    yield put(logoutUserError());
    yield call(logout);
    yield put(reset());
    yield put(logoutUserSuccess(true));
    yield call(readServicesSaga);
  } catch (error) {
    logError(error);
    yield put(logoutUserError(error.message));
  } finally {
    yield put(logoutUserBusy(false));
  }
}

export function* resetUserSaga(action) {
  const body = action.payload;
  try {
    yield put(resetUserBusy(BUSY_GLOBAL));
    yield put(resetUserError());
    const response = yield call(resetUser, body);
    yield put(resetUserSuccess(response ? response : "Success"));
  } catch (error) {
    logError(error);
    yield put(resetUserError(error.message));
  } finally {
    yield put(resetUserBusy(false));
  }
}

export function* verifyCodeSaga(action) {
  const body = toSnakeCase(action.payload);
  try {
    yield put(verifyCodeBusy(true));
    yield put(verifyCodeError());
    const response = yield call(verifyCode, body);
    yield put(verifyCodeSuccess(response ? response : "Success"));
  } catch (error) {
    logError(error);
    yield put(verifyCodeError(error.message));
  } finally {
    yield put(verifyCodeBusy(false));
  }
}

export default function* usersSaga() {
  yield takeLatest(FETCH_USER[REQUEST], readUserSaga);
  yield takeEvery(UPDATE_USER[REQUEST], updateUserSaga);
  yield takeLatest(LOGIN_USER[REQUEST], loginSaga);
  yield takeLatest(LOGOUT_USER[REQUEST], logoutSaga);
  yield takeLatest(RESET_USER[REQUEST], resetUserSaga);
  yield takeLatest(VERIFY_CODE[REQUEST], verifyCodeSaga);
}
